module.exports = __webpack_public_path__ + "img/match-schedule-icon.f931afdd.svg";